// Shared hour/minute helpers for the working-hours calendar UI, so the slot
// math and the compact "Xชม." label live in one place (used by the calendar
// cells, the side panel preview, and the resolved-slots box).

// Sum the duration (in minutes) of resolved slots: [{ start, end }, ...].
export const slotMinutes = (slots) =>
  (slots || []).reduce((acc, s) => {
    const [sh, sm] = s.start.split(":").map(Number);
    const [eh, em] = s.end.split(":").map(Number);
    return acc + (eh * 60 + em - sh * 60 - sm);
  }, 0);

// Compact hours label for cells / slot rows, e.g. "8ชม." or "8.5ชม.".
// Rounds to the nearest 0.1h and carries correctly — avoids the "5.10ชม."
// overflow that a naive one-decimal round produces for 57–59 minute totals.
export const formatHoursShort = (mins) => {
  const tenths = Math.round(mins / 6); // tenths of an hour
  const h = Math.floor(tenths / 10);
  const d = tenths % 10;
  return d === 0 ? `${h}ชม.` : `${h}.${d}ชม.`;
};
